import React from 'react';
import { BaseDialog, showDialog } from 'common/Dialogs/BaseDialog';
import { lang } from 'common/i18n';
import { makeTestId } from '../../../utils/helpers';

export interface UnpaidInvoice {
    /** @var number invoice number */
    num: number;
    /** @var string due date: "yyyy-mm-dd" */
    due: string;
    /** @var string URL of payment page */
    url: string;
}

interface UnpaidInvoicesDialogProps {
    invoices: UnpaidInvoice[];
    onCancel?: () => void;
}

export const UnpaidInvoicesDialog = ({ invoices, onCancel }: UnpaidInvoicesDialogProps) => (
    <BaseDialog open={true} title={lang('login.unpaid_invoices.dialog.title')} translate={lang} onCancel={onCancel}>
        <div className="unpaid-invoices">
            {invoices.map((invoice: UnpaidInvoice, index: number) => (
                <div className="unpaid-invoices__row" key={index}>
                    <span className="ld_h6 unpaid-invoices__label--number">{lang('login.unpaid_invoices.invoice_number.label')}</span>
                    <span className="ld_h6 unpaid-invoices__label--due">{lang('login.unpaid_invoices.due_date.label')}</span>
                    <span className="ld_body2 unpaid-invoices__value--number" {...makeTestId('unpaid-invoice', index, 'number')}>
                        {invoice.num}
                    </span>
                    <span className="ld_body2 unpaid-invoices__value--due" {...makeTestId('unpaid-invoice', index, 'due')}>
                        {invoice.due}
                    </span>
                    <a
                        className="ld_link unpaid-invoices__pay-link"
                        href={invoice.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        {...makeTestId('unpaid-invoice', index, 'pay')}
                    >
                        {lang('login.unpaid_invoices.pay.button')}
                    </a>
                </div>
            ))}
        </div>
    </BaseDialog>
);

export const showUnpaidInvoicesDialog = (invoices: UnpaidInvoice[]): void => {
    showDialog((_, negativeAction) => <UnpaidInvoicesDialog invoices={invoices} onCancel={negativeAction} />).catch(() => {
        // This dialog has no positive action and a rejection just means the user closed it.
    });
};
